import styled from '@emotion/styled';
import mediaQuery from '@/lib/styling/mediaQuery';
import SectionContentGroupContext from './SectionContentGroupContext';
import ContentGroupType from '@/lib/constants/challengeModel/ContentGroupType.enum';
import React from 'react';
import { type HTMLDivProps } from '@/lib/types';

type SectionLeftContentProps = HTMLDivProps & {
  children: React.ReactNode;
};

const StyledLeftContent = styled('div')({
  marginRight: 96,
  flex: 1,
  [mediaQuery(720)]: {
    marginRight: 56,
  },
  [mediaQuery(640)]: {
    marginRight: 0,
  },
});

const SectionLeftContent = (props: SectionLeftContentProps) => (
  <SectionContentGroupContext.Provider value={ContentGroupType.LEFT}>
    <StyledLeftContent {...props} />
  </SectionContentGroupContext.Provider>
);

export default SectionLeftContent;
